import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Input,
  Textarea,
  Button,
  FormControl,
  FormLabel,
  SimpleGrid,
  Icon,
  useToast,
  Link,
} from "@chakra-ui/react";
import {
  FaEnvelope,
  FaPhone,
  FaGithub,
  FaLinkedin,
  FaPaperPlane,
  FaInstagram,
} from "react-icons/fa";

const contactInfo = [
  {
    icon: FaEnvelope,
    label: "Email",
    value: "carltrebors0110@gmail.com",
    href: "mailto:carltrebors0110@gmail.com",
  },
  {
    icon: FaPhone,
    label: "Phone",
    value: "+63 997 507 1615",
    href: "tel:+15551234567",
  },
  //   {
  //     icon: FaMapMarkerAlt,
  //     label: "Location",
  //     value: "San Francisco, CA",
  //     href: "#",
  //   },
];

const socialLinks = [
  {
    icon: FaGithub,
    href: "https://github.com/Trebor-Katalbas",
    label: "GitHub",
  },
  {
    icon: FaLinkedin,
    href: "https://www.linkedin.com/in/trebor-katalbas02/",
    label: "LinkedIn",
  },
  {
    icon: FaInstagram,
    href: "https://www.instagram.com/trebor.katalbas/",
    label: "Instagram",
  },
];

const Contacts = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    setTimeout(() => {
      toast({
        title: "Message Sent!",
        description: "We'll get back to you as soon as possible.",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
      setFormData({ name: "", email: "", subject: "", message: "" });
      setIsSubmitting(false);
    }, 1500);
  };

  return (
    <Box id="contact" className="contact-section relative z-0" py={15}>
      <Container sx={{ paddingX: "0 !important"}} maxW="1200px">
        <VStack spacing={16}>
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <VStack spacing={6} textAlign="center">
              <h2 className="text-txt text-xl sm:text-3xl lg:text-5xl font-normal">
                Get In Touch
              </h2>
              <p className="text-zinc-500 text-sm sm:text-2xl lg:text-4xl font-light text-center">
                Have a project in mind? Let's work together to create something
                amazing. Drop a message and I'll get back to you!
              </p>
            </VStack>
          </motion.div>

          <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={12} width="100%">
            {/* Contact Form */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <Box
                as="form"
                onSubmit={handleSubmit}
                p={{base:5, sm:8}}
                bg="whiteAlpha.100"
                borderRadius="xl"
                backdropFilter="blur(10px)"
                border="1px solid"
                borderColor="whiteAlpha.200"
              >
                <VStack spacing={6}>
                  <SimpleGrid
                    columns={{ base: 1, md: 2 }}
                    spacing={6}
                    width="100%"
                  >
                    <FormControl isRequired>
                      <FormLabel color="gray.300">Name</FormLabel>
                      <Input
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Juan Dela Cruz"
                        bg="whiteAlpha.100"
                        border="1px solid"
                        borderColor="whiteAlpha.300"
                        _hover={{ borderColor: "#6778cb" }}
                        _focus={{
                          borderColor: "purple.400",
                          boxShadow: "0 0 0 1px purple.400",
                        }}
                        color="white"
                      />
                    </FormControl>
                    <FormControl isRequired>
                      <FormLabel color="gray.300">Email</FormLabel>
                      <Input
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="juancruz@example.com"
                        bg="whiteAlpha.100"
                        border="1px solid"
                        borderColor="whiteAlpha.300"
                        _hover={{ borderColor: "#6778cb" }}
                        _focus={{
                          borderColor: "purple.400",
                          boxShadow: "0 0 0 1px purple.400",
                        }}
                        color="white"
                      />
                    </FormControl>
                  </SimpleGrid>

                  <FormControl isRequired>
                    <FormLabel color="gray.300">Subject</FormLabel>
                    <Input
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="Project Discussion"
                      bg="whiteAlpha.100"
                      border="1px solid"
                      borderColor="whiteAlpha.300"
                      _hover={{ borderColor: "#6778cb" }}
                      _focus={{
                        borderColor: "purple.400",
                        boxShadow: "0 0 0 1px purple.400",
                      }}
                      color="white"
                    />
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel color="gray.300">Message</FormLabel>
                    <Textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your project..."
                      rows={6}
                      bg="whiteAlpha.100"
                      border="1px solid"
                      borderColor="whiteAlpha.300"
                      _hover={{ borderColor: "#6778cb" }}
                      _focus={{
                        borderColor: "purple.400",
                        boxShadow: "0 0 0 1px purple.400",
                      }}
                      color="white"
                      resize="vertical"
                    />
                  </FormControl>

                  <Button
                    type="submit"
                    size={{base: "sm", sm: "lg"}}
                    width="full"
                    isLoading={isSubmitting}
                    loadingText="Sending..."
                    bgColor="#6778cb"
                    color="white"
                    _hover={{
                      bgColor: "white",
                      color: "#6778cb",
                      transform: "translateY(-2px)",
                      boxShadow: "0 5px 20px rgb(103, 120, 203)",
                      textDecoration: "underline",
                    }}
                    leftIcon={<FaPaperPlane />}
                    transition="all 0.3s ease"
                  >
                    Send Message
                  </Button>
                </VStack>
              </Box>
            </motion.div>

            {/* Contact Info */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <VStack spacing={8} align="stretch" height="100%">
                {/* Contact Details */}
                <Box
                  p={{base:5, sm:8}}
                  bg="whiteAlpha.100"
                  borderRadius="xl"
                  backdropFilter="blur(10px)"
                  border="1px solid"
                  borderColor="whiteAlpha.200"
                >
                  <VStack spacing={6} align="start">
                    <Heading as="h3" size={{base:"sm", sm:"lg"}} color="white">
                      Contact Information
                    </Heading>
                    {contactInfo.map((info, index) => (
                      <motion.div
                        key={info.label}
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                      >
                        <HStack spacing={{base: 0, sm: 4}}>
                          <Icon as={info.icon} w={{base: 0, sm: 6}} h={{base: 0, sm: 6}} color="#6778cb" />
                          <Box>
                            <Text color="gray.400" fontSize="sm">
                              {info.label}
                            </Text>
                            <Link
                              href={info.href}
                              color="white"
                              fontSize={{base: "sm", sm: "md"}}
                              _hover={{
                                color: "#6778cb",
                                textDecoration: "underline",
                              }}
                            >
                              {info.value}
                            </Link>
                          </Box>
                        </HStack>
                      </motion.div>
                    ))}
                  </VStack>
                </Box>

                {/* Social Links */}
                <Box
                  p={{base:5, sm:8}}
                  bg="whiteAlpha.100"
                  borderRadius="xl"
                  backdropFilter="blur(10px)"
                  border="1px solid"
                  borderColor="whiteAlpha.200"
                >
                  <VStack spacing={6} align="start">
                    <Heading as="h3" size={{base: "sm", sm: "lg"}} color="white">
                      Socials
                    </Heading>
                    <HStack spacing={4}>
                      {socialLinks.map((social, index) => (
                        <motion.div
                          key={social.label}
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.95 }}
                        >
                          <Link
                            href={social.href}
                            isExternal
                            aria-label={social.label}
                          >
                            <Icon
                              as={social.icon}
                              w={8}
                              h={8}
                              color="gray.400"
                              transition="all 0.3s ease"
                              _hover={{ color: "#6778cb" }}
                            />
                          </Link>
                        </motion.div>
                      ))}
                    </HStack>
                  </VStack>
                </Box>
              </VStack>
            </motion.div>
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default Contacts;
